import { render, staticRenderFns } from "./PreviewScreemshot.vue?vue&type=template&id=0a82886e&scoped=true&"
import script from "./PreviewScreemshot.vue?vue&type=script&lang=ts&"
export * from "./PreviewScreemshot.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewScreemshot.vue?vue&type=style&index=0&id=0a82886e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a82886e",
  null
  
)

export default component.exports